<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.subscribers', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-patient' }" >
                        {{ $t('message.addPatient') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>


                    <b-container>
                        <b-row class="justify-content-sm-center">
                <p>

                 </p>

        <div v-if="!paiementReussi">
            <p>{{ $t('message.dejamomo') }} 
                <button class="btn btn-primary primary" small @click="checkStatutPaiement">Oui</button>

            </p>
            <div v-if="testAutomatique">
                <p>{{ $t('message.verification') }} {{nbreSecondes}} secondes / <strong>{{ Math.ceil(intervale) }}%</strong></p>
                
<!--                 <v-progress-linear
                    v-model="intervale"
                    height="25"
                >
                    <strong>{{ Math.ceil(intervale) }}%</strong>
                </v-progress-linear> -->
            </div>

                <button class="btn btn-primary primary"  small @click="procederAuPaiement">
                    {{ $t('message.initier') }}
                </button>
        </div>
        <div v-else>
           {{ $t('message.merci') }}
        </div>
                </b-row>
            </b-container>
        </div>
        </div>
    </div>
</template>

<script>
window.$ = window.jQuery = window.jquery = require('jquery');
    import Vue from 'vue';
    import Swal from 'sweetalert2';
    import {mapGetters} from "vuex";

    export default {
        name: "MomoNotification",

        computed: {
            ...mapGetters(['loader','accessToken']),
        },

        data(){
            return {
                reference:this.$route.params.reference,
                identifiant:this.$route.params.identifiant,
                intervale :0,
                milliSeconde:0,
                nbreSecondes:30,
                testAutomatique:true,
                paiementReussi:false,
            }
        },

        methods:{
            backAddAffiliation(){
                this.$router.push({name:'add-affiliation'});
            },

            procederAuPaiement() {
                this.$router.push({ name: 'paiement', params: { identifiant: this.identifiant } });
            },

            checkStatutPaiement(){
                let api_url = AppConfig.paymentUrl+"/api/v1.0.0/momo/statutPaiement";
                let self= this;
                let args = {
                    referenceId:self.reference,
                    identifiant:self.identifiant,
                    accessToken:self.accessToken,
                };

            $.ajax({
                url: api_url,
                type: "POST",
                body: JSON.stringify(args)
            })
                    .then(function (response) {
                        // handle success
                        if (response.statut == 'SUCCESSFUL'){
                            self.paiementReussi = true
                            self.testAutomatique = false;
                            Vue.swal.fire(
                                i18n.t('message.succes'),
                                i18n.t('message.visiteur.paiementReussi'),
                                'success'
                            )
                            $.ajax({
                                url: AppConfig.apiUrl+'/commande-restante/add/'+ (JSON.parse(localStorage.getItem('user')))['id'],
                                type: "POST",
                            })
                            .done(function(data) {
                                self.$router.push({ name: 'add-patient-souscripteur'});
                            })
                            .fail(function() {
                            });
                        } else if (response.data.statut == 'FAILED'){
                            self.testAutomatique = false;
                            if ((response.reason.reason).includes('INTERNAL_PROCESSING_ERROR')){
                                Vue.swal.fire(
                                    i18n.t('message.erreur'),
                                    '<html><head></head><body>' +
                                    '<p>Vérifier votre solde momo et réessayez</p> ' +
                                    '<p>Initier à nouveau le paiement </p>' +
                                    '</body></head></html>',
                                    'error'
                                )
                            }else if((response.reason).includes('400 Bad Request')){
                                Vue.swal.fire(
                                    i18n.t('message.erreur'),
                                    '<html><head></head><body>' +
                                    '<p>Vous n\'avez pas confirmez ou vous avez annulé l\'operation </p> ' +
                                    '<p>Initier à nouveau le paiement </p>' +
                                    '</body></head></html>',
                                    'error'
                                )
                            } else{
                                Vue.swal.fire(
                                    i18n.t('message.erreur'),
                                    response.reason,
                                    'error'
                                )
                            }

                        }else {
                            Vue.swal.fire(
                                'EN ATTENTE',
                                '<html><head></head><body>' +
                                '<p>Confirmez le paiement une seule fois sur votre téléphone ou taper *126# et confirmez. </p> ' +
                                '<p><strong>NB: Confirmez une seule fois</strong></p>' +
                                '</body></head></html>',
                                'warning'
                            )
                        }
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                    .then(function () {
                        // always executed
                    });
            }
        },

        mounted() {
            //Nous allons faire un ping sur les servers de orange jusqu'a ce que l'utilisateur ait
            // valider la transaction
            setInterval(ajaxCall, 30000);
            setInterval(progressBar, 1000);
            let self=this;

            function progressBar(){
                self.milliSeconde +=1000;
                self.intervale = (self.milliSeconde * 100)/30000;
                self.nbreSecondes -=1;

                if(self.intervale == 100 || self.loader == true){
                    self.milliSeconde =0;
                    self.intervale =0;
                    self.nbreSecondes =30;
                }
            }

            function ajaxCall() {
                //do your AJAX stuff here
                // Make a request for a user with a given ID
                if (self.testAutomatique){
                    self.checkStatutPaiement();
                }

            }
        }
    }
</script>

<style scoped>

</style>
